import { Component, OnInit } from '@angular/core';
import { UserModel } from "../../../shared/classes/UserModel";
import { UserViewModel } from "../../../shared/classes/UserViewModel";
import { GroupModel } from "../../../shared/classes/GroupModel";
import { GroupsService } from '../../../shared/services/groups.service';
import { UserService } from '../../../shared/services/user.service';
import { Adal4Service } from "adal-angular4";
import { Router, NavigationExtras } from "@angular/router";

@Component({
  selector: 'app-gerenciar-usuarios',
  templateUrl: './gerenciar-usuarios.component.html',
  styleUrls: ['./gerenciar-usuarios.component.css'],
  providers: [UserService, GroupsService]
})
export class GerenciarUsuariosComponent implements OnInit {
  listaUsuarios: UserModel[] = []
  listaGrupos: GroupModel[] = [];
  gruposDoUsuario: GroupModel[];
  mostrarCarregando;
  indiceUserSelecionado: number = -1;
  userSelecionado: UserModel = new UserModel();
  temp_userName: string;
  temp_userPhone: string;
  temp_userEmail: string;
  tituloJanela: string;
  isNewUser: boolean = true;
  disableNewUserButton = false;
  msgAviso: string;
  class_fa_icon_ok = "fa fa-thumbs-o-up fa-3x text-success";
  class_fa_icon_nok = "fa fa-thumbs-o-down fa-3x text-error";
  class_icon_msg: string;
  msgValidacaoCampos;
  idsGroupsToEdit: number[] = [];
  canDismissUserDetails: boolean = false;
  mostrarExportando: boolean;

  constructor(private adalService: Adal4Service, 
    private router: Router, 
    private userService: UserService, 
    private groupsService: GroupsService) { }

  ngOnInit() {  
    this.mostrarCarregando = true;
    this.getUsers();
  }
  

  getUsers(){
    this.userService.getUsers()
      .then(users => {        
        this.listaUsuarios = users;
        // var listaUsuariosOrdenados: UserModel[];

        // listaUsuariosOrdenados = this.listaUsuarios.slice(0);
        // listaUsuariosOrdenados.sort((leftSide, rightSide): number => {
        //   if(leftSide.principalDisplayName < rightSide.principalDisplayName) return -1;
        //   if(leftSide.principalDisplayName > rightSide.principalDisplayName) return 1;
        //   return 0;
        // });
        // this.listaUsuarios = listaUsuariosOrdenados.slice(0);
        
        this.mostrarCarregando = false;
        localStorage.setItem("usuarios", JSON.stringify(this.listaUsuarios));        
      }).catch(error => {
        this.msgAviso = error.text() || <any>error;
        this.class_icon_msg = this.class_fa_icon_nok;
        this.mostrarCarregando = false;
        document.getElementById("showMensagensModal4").click();
      });
  }

  exportUsersToExcel(){
    //alert("Chamou o método");
    this.mostrarExportando = true; 
    console.log("lista usuarios a ser enviado pro export:", this.listaUsuarios);  
    this.userService.exportExcelUsers(this.listaUsuarios).then(url => {
      this.mostrarExportando = false;      
      window.open(url);
    }).catch(error => {
      this.mostrarExportando = false;
      this.msgAviso = error.text();// || <any>error;
      if(error.status == 403 || error.status == 401){
        this.msgAviso = "Sua sessão expirou ou você não tem permissão para acessar este recurso.";
        //this.router.navigate(['/home']);           
      }
      this.class_icon_msg = this.class_fa_icon_nok;
      document.getElementById("showMensagensModal3").click();
    });
  }

  // saveUser(){
  //   if(this.indiceUserSelecionado >= 0 || this.isNewUser){
     
  //     var userVm = new UserViewModel();
  //     userVm.user = this.userSelecionado;     
  //     userVm.groupsIds = this.getSelectGroups();
  //     if(!this.isNewUser){        
        
  //       if(!this.validateNewUser(userVm)){
  //         setTimeout(() => {
  //           this.msgValidacaoCampos = null;
  //         }, 5000);
  //         return;
  //       }
  //       this.userService.updateUser(this.userSelecionado.id, userVm).then(user => {
  //         //console.log("user from service update:", user);
  //         this.isNewUser = false;
  //         this.listaUsuarios[this.indiceUserSelecionado] = user;          
  //         localStorage.setItem("usuarios", JSON.stringify(this.listaUsuarios));
  //         this.msgAviso = "Usuário editado com sucesso! - "+ user.nomeCompleto;
  //         this.idsGroupsToEdit = [];
  //         this.class_icon_msg = this.class_fa_icon_ok;
          
  //         document.getElementById("showMensagensModal4").click();

       
  //       }).catch(erro => {
  //         this.msgAviso = erro.text() || <any>erro;
  //         this.class_icon_msg = this.class_fa_icon_nok;
  //         document.getElementById("showMensagensModal4").click();
  //       })
  //     }else{
        
  //       userVm.groupsIds = this.getSelectGroups()

  //       if(!this.validateNewUser(userVm)){
  //         setTimeout(() => {
  //           this.msgValidacaoCampos = null;
  //         }, 3500);
  //         return;
  //       }
  //       document.getElementById("dismissUserDetails").click();
  //       this.userService.addUser(userVm).then(user => {          
          
  //         this.isNewUser = false;
  //         this.listaUsuarios.push(user);
  //         this.msgAviso = "Usuário criado com sucesso! - "+ user.nomeCompleto;      
  //         this.class_icon_msg = this.class_fa_icon_ok;          
  //         localStorage.setItem("usuarios", JSON.stringify(this.listaUsuarios));
  //         document.getElementById("showMensagensModal4").click();
  //         this.canDismissUserDetails = false;
  //       }).catch(error => {
  //         this.msgAviso = error.text() || <any>error;
  //         this.class_icon_msg = this.class_fa_icon_nok;
  //         document.getElementById("showMensagensModal4").click();
  //       })
  //     }
     
     
  //   }
  // }

  // loadGroups(){
  //   console.log("chmou o load groups");
  //   // var grupoStorage = localStorage.getItem("grupos");
  //   // if (grupoStorage){
  //   //   this.listaGrupos = JSON.parse(grupoStorage);
  //   //   return;
  //   // }
  //   this.groupsService.getGroups().then(grupos =>{
  //     this.listaGrupos = grupos;
  //     console.log("listagroups depois do serviço", this.listaGrupos);
  //   }).catch(erro => {
  //     this.msgAviso = erro.text() || <any>erro;
  //     this.class_icon_msg = this.class_fa_icon_nok;
  //     document.getElementById("showMensagensModal4").click();
  //   });
  // }

  // setAllGroupsSelectedFalse(){
  //   if(this.listaGrupos && this.listaGrupos.length > 0){
  //     this.listaGrupos.forEach(grupo => {
  //       grupo.selected = false; 
  //     });
  //   }
  // }

  // addUser(){
  //   this.canDismissUserDetails = true;
  //   this.resetSelectedUser();
  //   this.isNewUser = true;
  //   this.tituloJanela = "Cadastrar Usuário";
  //   this.loadGroups();
  // }

  // getSelectGroups() : number[]{
  //   var idsGruposSelecionados = this.listaGrupos.filter((g) => g.selected).map((gr) => gr.id);    
  //   return idsGruposSelecionados;        
  // }

  // getIdsGroupsEdit(grupo: GroupModel){
  //   console.log("grupo", grupo)
  //   if(!this.isNewUser && grupo.selected){
  //     this.idsGroupsToEdit.push(grupo.id);
  //     console.log("grupo selected?", grupo.selected);
  //   }
  //   if(!this.isNewUser && !grupo.selected ){
  //     if(this.idsGroupsToEdit.indexOf(grupo.id) > -1){
  //       for (var i = 0; i < this.idsGroupsToEdit.length; i++) {
  //         if(this.idsGroupsToEdit[i] == grupo.id){    
  //           this.idsGroupsToEdit.splice(i, 1);
  //         }        
  //       }
  //     }else{
  //       this.idsGroupsToEdit.push(grupo.id);
  //     }      
  //   }
    // console.log("chamou checkGroup")
    // console.log("grupo selected?", grupo.selected)
    // console.log("listaGrupos", this.listaGrupos);
    // console.log("grupos do usuario", this.userSelecionado.meusGrupos);    
  //}

  // setIndexUserToDelete(i:number){
  //   this.indiceUserSelecionado = i;
  // }

  // deleteUser(){
  //   if(this.indiceUserSelecionado > 0){
  //     var idUser = this.listaUsuarios[this.indiceUserSelecionado].id;
  //     console.log("id usuario para exclusão", idUser);
  //     this.userService.deleteUser(idUser).then(deleted => {
  //       this.msgAviso = "Usuário excluido com sucesso";
  //       this.class_icon_msg = this.class_fa_icon_ok;
  //       document.getElementById("showMensagensModal4").click();
  //       this.listaUsuarios.splice(this.indiceUserSelecionado, 1);
  //       localStorage.setItem("usuarios", JSON.stringify(this.listaUsuarios))
  //     }).catch(erro => {
  //       this.msgAviso = erro.text() || <any>erro;
  //       this.class_icon_msg = this.class_fa_icon_nok;
  //       document.getElementById("showMensagensModal4").click();
  //     })
  //   }
  // }

  // editUser(i:number){
  //   this.setAllGroupsSelectedFalse();
  //   this.canDismissUserDetails = true;
  //   this.isNewUser = false;
  //   this.indiceUserSelecionado = i;

   
  //   this.tituloJanela = "Editar Usuário";
  //   this.userSelecionado = new UserModel();
  //   this.userSelecionado.id = this.listaUsuarios[i].id;
  //   this.userSelecionado.nomeCompleto = this.listaUsuarios[i].nomeCompleto;
  //   this.userSelecionado.email = this.listaUsuarios[i].email;
  //   this.userSelecionado.telefone = this.listaUsuarios[i].telefone;
  //   this.userSelecionado.gruposUsuarios = this.listaUsuarios[i].gruposUsuarios;

    
    
  //   var idsGruposDoUsuario =  this.userSelecionado.gruposUsuarios.map((g) => g.groupId);
  //   this.listaGrupos.forEach(grupo => {      
  //     if(idsGruposDoUsuario.some((id) => id == grupo.id)){
  //       grupo.selected = true;        
  //     }
  //   });    
  // }

  

  // validateNewUser(userVm: UserViewModel): boolean {

  //   var nomeValido = userVm.user.nomeCompleto != "" && userVm.user.nomeCompleto.length > 3;    
  //   var emailValido = userVm.user.email.indexOf("@") > -1 && userVm.user.email.indexOf(".") > -1

  //   if(!nomeValido || !emailValido){
  //     console.log("email inválido");
  //     this.msgValidacaoCampos = "Certifique-se que todos os campos estão preenchidos corretamente.";      
  //     return false;
  //   }
  //   if(this.getSelectGroups().length == 0){//!userVm.groupsIds || userVm.groupsIds.length <= 0){
  //     if(this.isNewUser){
  //       this.msgValidacaoCampos = "Você precisa adicionar o usuário a pelo menos 1 grupo.";
  //     }else{
  //       this.msgValidacaoCampos = "O usuário precisa permanencer em pelo menos 1 grupo";
  //     }      
  //     return false;
  //   }
  //   return true;
  // }

  // resetSelectedUser(){
  //   this.userSelecionado.id = 0;
  //   this.userSelecionado.email = "";
  //   this.userSelecionado.nomeCompleto = "";
  //   this.userSelecionado.telefone = "";
  //   this.userSelecionado.matricula = "";
  //   this.userSelecionado.gruposUsuarios = null;
  // }

  // closeUserDetails(){
  //   if(this.canDismissUserDetails){
  //      document.getElementById("dismissUserDetails").click();
  //      this.canDismissUserDetails = false;
  //   }   
  // }

}



// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/paginas/administracao/gerenciar-usuarios/gerenciar-usuarios.component.ts